<template>
    <div class="sport-subnav">
        <div
            v-if="isTimeFilterDropdownExpanded"
            class="modal__overlay"
            @click="closeSidebar"
        >
        </div>
        <router-link
            :to="{ name: allOfferRoute  }"
            tag="div"
            class="nav-sidebar-tree__item"
        >
            <div class="mobile-subnav__item-wrapper">
                <div class="flex__align-center">
                    <i class="icon--md icon-chevron_left  nav-sidebar-tree__icon"></i>
                </div>
                <span class="mobile-subnav__item-text">
                    {{ $t('back to offer') | upperCase }}
                </span>
            </div>
        </router-link>
        <button
            class="mobile-subnav__item mobile-subnav__item--secondary"
            @click="onTimeFilterClick"
        >
            <div class="flex__align-center">
                <i class="icon--md icon-events mr-2"/>
                <span class="mobile-subnav__item-text">
                    {{ important }}
                </span>
            </div>
        </button>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import { timeFilterMixing } from '@app/modules/shared/timeFilter/mixins/timeFilter';
    import { routeNames } from '@app/router';
    import { SidebarId } from '@app/store/modules/ui/mobile/enums';

    export default {
        mixins: [timeFilterMixing],
        created() {
            this.allOfferRoute = routeNames.landing;
        },
        methods: {
            ...mapActions('ui/mobile', [
                'toggleSidebar',
                'closeSidebar',
            ]),
            onTimeFilterClick() {
                this.toggleSidebar(SidebarId.specialsTimeFilter);
            },
        },
        computed: {
            ...mapGetters('ui/mobile', ['isSidebarOpen']),
            ...mapGetters('ui/special', [
                'timeFilter',
            ]),
            isTimeFilterDropdownExpanded() {
                return this.isSidebarOpen(SidebarId.specialsTimeFilter);
            },
            timeFilterId() {
                return this.timeFilter;
            }
        },
    };
</script>


// WEBPACK FOOTER //
// src/app/mobile/specials/SpecialsSubNav.vue